const rules= {
    required: value => !!value || 'Required.',
    requiredNumberPositive: value => !!value && (value >= 1) || 'กรุณากรอกตัวเลขที่มีค่ามากกว่า 0',
    requiredNumber: value => !!value && (value >= 0) || 'กรุณากรอกตัวเลขที่มีค่ามากกว่าหรือเท่ากับ 0',
    requiredMinMaxNumber(min, max) { return value => ((value >= min && value <= Number(max))) || 'กรุณากรอกตัวเลขที่มีค่าระหว่าง ' + min + ' - ' + max},
    requiredMaxNumber(max) { return value => (value >= 0 && value <= Number(max)) || 'กรุณากรอกตัวเลขที่มีค่าไม่เกิน ' + max},
    requiredObject: value => {
        return !!value.licenseNo || 'Required.'
    },
    requiredConsumable: value => {
        return !!value.consumableCode || 'Required.'
    },
    requiredTime: value => {
        let reg = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return reg.test(value) || 'Required.'
    },
    formatTime: value => {
        let reg = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return (!value || (!!value && reg.test(value))) || 'Required.'
    },
    requiredLetterOrNumber: value => {
        let reg = /^[A-Za-z0-9-_]+$/;
        return reg.test(value) || 'กรุณากรอกข้อมูล A-Z, 0-1 เท่านั้น'
    },
    requiredMobile: value => {
        let reg = /^[0-9,-_]+$/;
        return reg.test(value) || 'กรุณาเบอร์โทรให้ถูกต้อง'
    },
    validateTransType(transType, max) {
        return transType == '1' ? this.requiredNumber : this.requiredMinMaxNumber(1, max);
    }
}


export default rules;